module.exports = __webpack_public_path__ + "static/fonction7-81a53c91bce72e55c883183c60dc7cff.jpg";